/**
 * Module: slots API
 * Role: Slot mutation helpers for /api/v2/buyer/slots (BUG-1309)
 * Uses: ./client (apiFetch)
 * Used by: FlowScreen (cancel CTA)
 */
import { apiFetch } from './client';

export interface CancelSlotResponse {
  slot_id: string;
  status: string;
}

export async function cancelSlot(slotId: string): Promise<CancelSlotResponse> {
  return apiFetch<CancelSlotResponse>(
    `/api/v2/buyer/slots/${slotId}/cancel`,
    { method: 'POST' },
  );
}
